import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  
import { statusCheck } from '../public';

export const useWithdrawStore = defineStore('withdraw', {
  state: () => ({
    transactions: [],
    totalEntries:'',
    feesAndRefunds: '',
    history: [],
    checkData: [],
    confirmData: [],
    filters: {
      from: '',
      to: '',
    },
  }),
  actions: {
    async fetchTransactions() {
      const url = `/api/driver/withdraw/transaction`;
      let params = new URLSearchParams();
      
      params.append('per_page', 99999);
      params.append('page', 1);
      if (this.filters.from) params.append('from', this.filters.from);
      if (this.filters.to) params.append('to', this.filters.to);
      try {
        const response = await useHttp().get(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          this.transactions = response.data.transactions;
          this.totalEntries = response.data.total;
          this.feesAndRefunds= response.data.fees_and_refunds;
        } else {
          console.error('Failed to fetch transactions:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
      }
    },
    async checkWithdraw(transaction_ids) {
      const url = `/api/driver/withdraw/check`;
      const payload = {
        transaction_ids: transaction_ids,
      };
      try {
        const response = await useHttp().post(url,payload);
        if (statusCheck(response.data)) {
          this.checkData = response.data;
          
          return true;
        } else {
          console.error('Failed to fetch history:', response.data.message);
          return false;
        }
      } catch (error) {
        console.error('Error fetching history:', error);
        throw error;
      }
    },
    async confirmWithdraw(transaction_ids) {
      const url = `/api/driver/withdraw/confirm`;
      const payload = {
        transaction_ids: transaction_ids,
      };
      try {
        const response = await useHttp().post(url,payload);
        if (statusCheck(response.data)) {
          this.confirmData = response.data.data;
          return true;
        } else {
          this.confirmData = response.data.data;
          return false;
        }
      } catch (error) {
        console.error('Error fetching history:', error);
        throw error;
      }
    },
    async fetchWithdrawHistory() {
      const url = `/api/driver/withdraw/list`;
      try {
        const response = await useHttp().get(`${url}`);
        if (statusCheck(response.data)) {
          this.history = response.data.payments;
        } else {
          console.error('Failed to fetch history:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching history:', error);
        throw error;
      }
    },
  },
});
